import { FETCH_REPORT_CASES_LOADING } from '../actions/types'

function reportCasesLoadingReducer(state = false, action) {
    switch (action.type) {
        case FETCH_REPORT_CASES_LOADING:
            return action.payload
        default:
            return state
    }
}

export default reportCasesLoadingReducer